class AccessUser {
    static ACTION = {
        READ: parseInt("00001", 2),
        CREATE: parseInt("00010", 2),
        UPDATE: parseInt("00100", 2),
        DELETE: parseInt("01000", 2),
        VALIDATE: parseInt("10000", 2)
    };
    static VALIDATE = [AccessUser.ACTION.READ, AccessUser.ACTION.CREATE, AccessUser.ACTION.UPDATE, AccessUser.ACTION.VALIDATE];
    static CONTRIBUTE = [AccessUser.ACTION.READ, AccessUser.ACTION.CREATE, AccessUser.ACTION.UPDATE];
    static ADMIN = Object.values(AccessUser.ACTION);

    static SUPPER_ADMIN = "super_administrator";
    static DIAM_ADMIN = "diam_administrator";
    static CLIENT_ADMIN = "client_administrator";
    static BOTH_ADMIN = "both_admin";

    static TYPE_DIAM = 0;
    static TYPE_CLIENT = 1;

    static roleToBinary(roles) {
        const res = roles.reduce((obj, role) => {
            obj[role.name] = role.accesses.reduce((binary, action) => {
                return AccessUser.ACTION[action] | binary;
            }, 0);
            return obj;
        }, {});

        return res;
    }
}

export default AccessUser;



// WEBPACK FOOTER //
// ./src/plugins/AccessUser.js